"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleHttpResponse = exports.ArcxApi = void 0;
class ArcxApi {
    constructor(arcxUrl) {
        this.arcxUrl = arcxUrl;
    }
    fetchFromApi(...[url, ...args]) {
        return __awaiter(this, void 0, void 0, function* () {
            return fetch(`${this.arcxUrl}${url}`, ...args).then(handleHttpResponse);
        });
    }
    // async getScoreProof(
    //   userAddress: string,
    //   chainId: string,
    // ) {
    //   const response = await this.fetchFromApi(`/reputation/${userAddress}/arcx.creditScore`,
    //     {
    //       headers: {
    //         chain_id: chainId,
    //       },
    //     },
    //   )
    //   return response as ReputationScore
    // }
    getPassportMetadata(userAddress, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fetchFromApi(`/passports/${userAddress}`, {
                headers: {
                    chainId: chainId,
                },
            });
            return response;
        });
    }
}
exports.ArcxApi = ArcxApi;
function getResponseValue(res) {
    return __awaiter(this, void 0, void 0, function* () {
        return res.text().then((text) => {
            try {
                return JSON.parse(text);
            }
            catch (err) {
                return text;
            }
        });
    });
}
function handleHttpResponse(res) {
    return __awaiter(this, void 0, void 0, function* () {
        if (res.ok) {
            return getResponseValue(res);
        }
        return getResponseValue(res).then((value) => Promise.reject(value));
    });
}
exports.handleHttpResponse = handleHttpResponse;
// interface ReputationScore {
//   score: string | null
// }
